import {Stack} from "@mui/material";
import {AddOutlined, RemoveOutlined} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import React, {Dispatch, FC, SetStateAction, useEffect, useMemo, useState} from "react";
import {getTextColorOnRecommended} from "../../../../../../util/utils";
import TextField from "@mui/material/TextField";
import {validateQtyInput} from "../../../../../../util/regex";
import {Swiper as SwiperType} from "swiper";

interface Props {
    qty: any
    setQty: Dispatch<SetStateAction<any>>
    recommended: boolean
    max?: number
    size?: 'small' | 'medium' | 'large'
    swiperInstance?: SwiperType
}


const QtySelector: FC<Props> = ({size = 'small', ...props}) => {
    const [inputWidth, setInputWidth] = useState(12)

    const DEFAULT_FONT_SIZE = useMemo(() => size === 'small' ? 11.5 : 16, [size])
    useEffect(() => {
        const qtyLength = String(props.qty).length
        if (qtyLength === 0) {
            setInputWidth(DEFAULT_FONT_SIZE)
            return
        }
        setInputWidth(qtyLength * DEFAULT_FONT_SIZE)
    }, [props.qty, DEFAULT_FONT_SIZE])

    const handleInputChange = (e: any) => {
        const value = e.target.value
        if (!value.trim()) {
            props.setQty("")
        }
        if (validateQtyInput(value) && props.max && Number(value) <= props.max) {
            props.setQty(Number(value))
        }
    }

    const handleInputBlur = () => {
        if (props.qty === "") {
            props.setQty(1)
        }
    }

    const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>, qty: number) => {
        e.preventDefault()
        e.stopPropagation()
        props.swiperInstance?.autoplay?.stop()
        props.setQty(qty)
    }

    const disableIncreaseButton = useMemo(() => {
        if (props.qty >= 99) {
            return true
        }
        if (props.max) {
            return props.qty >= props.max
        }
        return false
    }, [props.max, props.qty])

    return (
        <Stack spacing={0.5} direction="row">
            <IconButton sx={{color: getTextColorOnRecommended(props.recommended)}}
                        size="small"
                        disabled={props.qty <= 1}
                        onClick={(e) => handleButtonClick(e, props.qty - 1)}><RemoveOutlined/></IconButton>
            <TextField value={props.qty}
                       name="qty"
                       color="primary"
                       variant="standard"
                       autoComplete="off"
                       InputProps={{
                           disableUnderline: true,
                       }}
                       sx={{alignSelf: 'center'}}
                       onFocus={() => props.swiperInstance?.autoplay?.stop()}
                       inputProps={{
                           style: {
                               color: getTextColorOnRecommended(props.recommended),
                               textAlign: 'center',
                               width: `${inputWidth}px`,
                               fontWeight: 600,
                               padding: 0,
                               fontSize: size === 'small' ? '1.10rem' : '1.5rem'
                           }
                       }}
                       onBlur={handleInputBlur}
                       onChange={handleInputChange}/>

            <IconButton sx={{color: getTextColorOnRecommended(props.recommended)}}
                        size="small"
                        disabled={disableIncreaseButton}
                        onClick={(e) => handleButtonClick(e, props.qty + 1)}><AddOutlined/></IconButton>
        </Stack>
    )
}

export default QtySelector
